export const ALERT_TYPE = {
  ERROR: "error",
  INFO: "info",
  SUCCESS: "success",
} as const;

export type TypeAlert = (typeof ALERT_TYPE)[keyof typeof ALERT_TYPE];

interface Alerts {
  icon: string;
  className: string;
}

export const ALERTS_CONFIG: Record<TypeAlert, Alerts> = {
  success: {
    icon: "mdi-check",
    className: "success-alert",
  },
  error: {
    icon: "mdi-alert-circle-outline",
    className: "error-alert",
  },
  info: {
    icon: "mdi-information-outline",
    className: "info-alert",
  },
};

export const ALERTS_ACTIVE_TIME = 5000;
